import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useNavigate, useParams } from "react-router-dom";
import { FieldValue, serverTimestamp } from "firebase/firestore";

import { db } from "../lib/firebaseCompat";
import Layout from "../components/shared/Layout";
import Loading from "../components/shared/Loading";

import { useScrollToTop } from "../hooks/use-scroll-to-top";
import { useOrganization } from "../hooks/useOrganization";
import { useAuth } from "../hooks/usehooks.com/use-auth";

// @TODO update to yum schema
const defaultEstimate = {
  businessName: "",
  dba: "",
  industryName: "",
  accountNumber: "",
  parcelNumber: "",
  streetAddress: "",
  city: "",
  stateAbr: "",
  zip: "",
  contactName: "",
  contactEmail: "",
  phone: "",
  notes: "",
  status: "draft",
  archived: false,
  naics: "",
  startedOn: "",
  assets: [],
  costs: {},
  newAsset: {
    name: "",
    cost: 0,
  },
};

const initialState = {
  loaded: false,
  template: defaultEstimate,
};

export default function NewEstimate() {
  useScrollToTop();
  const organization = useOrganization();
  const { id: templateId } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState(initialState);
  const { user } = useAuth();

  const orgId = organization.current?.id;
  const orgState = organization.current?.state;
  const { loaded, template } = state;
  const assets = [];
  const estimate = { assets, ...template };
  const initialEstimate = { ...defaultEstimate, ...estimate };

  useEffect(() => {
    const ref = db.collection("templates").doc(templateId);

    (async () => {
      const doc = await ref.get();
      const template = doc.data();
      setState({ loaded: true, template });
    })();
  }, [db, templateId]);

  useEffect(() => {
    if (!loaded) {
      return;
    }

    if (!orgId) {
      console.error("currentOrganization is not set on User.");
      return;
    }

    // @TODO extract into business logic hook
    const ref = db
      .collection("organizations")
      .doc(orgId)
      .collection("estimates")
      .doc();

    const {
      name: industryName,
      costs,
      averageEmployees,
      ...estimateData
    } = initialEstimate;
    const employees = averageEmployees;

    const initialCosts = costs[orgState] || costs["USA"] || [];
    const initialAssets = initialCosts.map((a) => {
      const cost =
        a.calculateBy === "EMPLOYEE" ? a.amount * employees : a.amount;
      return { ...a, cost };
    });

    const subtotal = initialAssets.reduce((sum, a) => {
      return sum + a.cost;
    }, 0);

    const year = new Date().getFullYear();

    const data = {
      ...estimateData,
      industryName,
      employees,
      initialAssets,
      assets: initialAssets,
      subtotal,
      adjustmentFactor: 0,
      total: subtotal,
      year,
      createdBy: user.uid,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    (async () => {
      await ref.set(data);
      const docId = ref.id;
      navigate(`/edit/${docId}`);
    })();
  }, [orgId, user, db, loaded, template]);

  return (
    <Layout>
      {!loaded ? "Loading template..." : "Saving new estimate..."}
    </Layout>
  );
}
